import React from 'react';

import { Link } from 'react-router-dom';

import AppRoutes from 'routes/routes';

const Button = (props) => {
  const { text = '', className = '', type = 'submit', color = 'primary', to = AppRoutes.home, icon = null, children = <></>, ...rest } = props;

  const colorStyles = {
    primary: 'bg-primary-346 text-white',
    outline: 'bg-transparent border border-solid border-gray-651',
    secondary: 'bg-gray-651 border border-solid border-gray-651',
    danger: 'bg-danger-229 text-white',
    'danger-outline': 'bg-transparent border border-solid border-danger-229 text-danger-229',
    white: 'bg-white text-black/85',
  };

  if (type === 'link') {
    return (
      <Link
        to={to}
        type={type}
        className={`flex items-center justify-center py-1.5 px-4 rounded-sm text-base ${colorStyles[color]} ${className}`}
        {...rest}
      >
        {icon ? <>{icon}</> : <></>}
        <span className="text-nowrap whitespace-nowrap">
          {icon && text ? <>&nbsp;</> : ''}
          {text}
        </span>
        {children ?? <></>}
      </Link>
    );
  }

  return (
    <button type={type} className={`flex items-center justify-center py-1.5 px-4 rounded-sm ${colorStyles[color]} ${className}`} {...rest}>
      {icon ? <>{icon}</> : <></>}
      <span className="text-nowrap whitespace-nowrap">
        {icon && text ? <>&nbsp;</> : ''}
        {text ?? ''}
      </span>
      {children ?? <></>}
    </button>
  );
};

export default React.memo(Button);
